// extracted by mini-css-extract-plugin
module.exports = {"close":"Modal_close__3i5bd","disabled":"Modal_disabled__1Opp1","pg-close":"Modal_pg-close__2kXoy"};